import { render } from "./AfterStoryDetailsModal.vue?vue&type=template&id=1c620fed&scoped=true"
import script from "./AfterStoryDetailsModal.vue?vue&type=script&lang=js"
export * from "./AfterStoryDetailsModal.vue?vue&type=script&lang=js"

import "./AfterStoryDetailsModal.vue?vue&type=style&index=0&id=1c620fed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c620fed"]])

export default __exports__